import { h, render } from 'preact';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from "styled-components";

import { HOST_BUSINESS } from 'utils/constants';

import Button from 'components/Button';
import Column from 'components/Column';
import ContainerAd from 'components/Container/ContainerAd';
import ContentAd from 'components/Content/ContentAd';
import Footer from 'components/Footer';
import H2 from 'components/H2';
import H3 from 'components/H3';
import Img from 'components/Img';
import P from 'components/P/PAd';

import messages from '../messages';

import TemplateIcon from '../images/template-icon.svg'
import ChevronRight from '../images/chevron-right.svg'

const Title = styled(H2)`
  max-width: 340px;
  margin: 20px auto 5px;
  font-size: 18px;

  @media (min-width: 992px) {
    font-size: 24px;
    max-width: 580px;
  }
`

const Description = styled(P)`
  width: 100%;
  margin: 0 auto 10px;
  font-size: 14px;
  max-width: 340px;

  @media (min-width: 992px) {
    font-size: 16px;
    max-width: 550px;
  }
`

const PriceWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: baseline;
`

function getURL(props) {
  const location = props.matches.location;
  const category = props.matches.category;
  const url = props.matches.url;
  const version = props.matches.version;
  const cohort = props.matches.cohort;

  if (location.includes("summary")) {
    return HOST_BUSINESS + "/template?utm_source=hukumonline&utm_medium=iframe&utm_campaign=all_template_landing_page&utm_content=intisari&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else if (location === "ulasan-top") {
    return HOST_BUSINESS + "/template?utm_source=hukumonline&utm_medium=iframe&utm_campaign=all_template_landing_page&utm_content=ulasan1&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else if (location == "ulasan-bottom") {
    return HOST_BUSINESS + "/template?utm_source=hukumonline&utm_medium=iframe&utm_campaign=all_template_landing_page&utm_content=ulasan2&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else {
    return HOST_BUSINESS + "/template?utm_source=hukumonline&utm_medium=iframe&utm_campaign=all_template_landing_page&utm_content=uncategorized&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  }
}

function Price() {
  return (
    <PriceWrapper>
      <P style={{ fontSize: '12px', marginRight: '10px' }}>{"Mulai dari"}</P>
      <H3 style={{ fontSize: '20px', margin: '0px', color: '#003366' }}>{"Rp100.000"}</H3>
    </PriceWrapper>
  )
}

function CTAButton(props) {
  return (
    <Button
      href={getURL(props)}
      blank="_blank"
      color='yellow'
      size="medium"
      style={{ maxWidth: '248px', marginBottom: '15px' }}
    >
      <FormattedMessage {...messages.cta_text} />
      <div style={{ display: 'inline-block', width: '30px', marginRight: '-25px' }}>
        <Img alt="cta template" src={ChevronRight} style={{ height: '15px', marginBottom: '-2px' }} />
      </div>
    </Button>
  )
}

function TemplateAd(props) {
  return (
    <ContainerAd>
      <ContentAd>
        <Title><FormattedMessage {...messages.title} /></Title>
        <Description><FormattedMessage {...messages.description} /></Description>
        <Img
          src={TemplateIcon}
          alt="Template Icon"
          style={{ height: '50px' }}
        />
        <Price />
        <CTAButton {...props} />
        <Footer />
      </ContentAd>
    </ContainerAd>
  )
}

export default injectIntl(TemplateAd);
